import { render, staticRenderFns } from "./im-static-list-message.vue?vue&type=template&id=966f2d3c&scoped=true"
import script from "./im-static-list-message.vue?vue&type=script&lang=js"
export * from "./im-static-list-message.vue?vue&type=script&lang=js"
import style0 from "./im-static-list-message.vue?vue&type=style&index=0&id=966f2d3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "966f2d3c",
  null
  
)

export default component.exports